import InboxContainer from '../unified-inbox/components/InboxContainer';
import OnboardingTour from '../new-feature-onboarding/components/OnboardingTour';
import { jsx as _jsx } from "react/jsx-runtime";
const InboxContainerWithOnboarding = props => {
  return /*#__PURE__*/_jsx(OnboardingTour, {
    children: /*#__PURE__*/_jsx(InboxContainer, {
      match: props.match
    })
  });
};
InboxContainerWithOnboarding.displayName = 'InboxContainerWithOnboarding';
export default InboxContainerWithOnboarding;